import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import Slider from "react-slick";

import bg1 from '../../assets/img/p-1.jpg'
import bg2 from '../../assets/img/p-2.jpg'
import bg3 from '../../assets/img/p-3.jpg'
import bg4 from '../../assets/img/p-4.jpg'
import bed from '../../assets/img/bed.svg'
import bathtub from '../../assets/img/bathtub.svg'
import move from '../../assets/img/move.svg'

import Navbar from '../../components/navbar/navbar'
import PropertyDetail from '../../components/property-detail';
import DetailSidebar from '../../components/detail-sidebar';
import FooterTop from '../../components/footer-top';
import Footer from '../../components/footer';

import { propertyData } from '../../data/data';
import { useHooks } from '../../utils/getHooks';
import { viewSpaceDetails } from '../../services/ApiServices';
import { BsDoorOpen } from "react-icons/bs";
import processor from '../../assets/css/plugins/ajax-loader.gif'

export default function SinglePropertyOne() {
    const [spaceDetails, setSpaceDetails] = useState<any>();
    const [isProcessing, setProcessing] = useState<boolean>(false);

    console.log("spaceDetails", spaceDetails);

    let params = useParams()
    let id: any = params.id
    let data = propertyData.find((item: any) => item.id === parseInt(id))

    const totalImages = spaceDetails?.images?.length || 0;
    const slidesToShow = totalImages > 1 ? Math.min(2, totalImages) : 1;

    const settings = {
        dots: true,
        slidesToShow,
        slidesToScroll: 1,
        speed: 3000,
        centerMode: false,
        infinite: totalImages > slidesToShow,
    };

    // const settings = {
    //     dots: true,
    //     slidesToShow: spaceDetails?.images?.length > 1 ? 2 : 1, // Show 3 slides if more than 1 image, otherwise 1
    //     // infinite: spaceDetails?.images?.length > 1, // Disable infinite scrolling for a single image
    //     // autoplay: true, // Disable autoplay for a single image
    //     // autoplaySpeed: 2000,
    //     speed: 3000,
    //     slidesToScroll: 1,
    //     centerMode: false,
    // };

    const spaceDetailAPICall = () => {
        setProcessing(true);
        viewSpaceDetails(params?.spaceId).then((res) => {
            console.log("spaceDetails res", res);
            const spaceDetail: any = res?.space_detail
            setSpaceDetails(spaceDetail)
            setProcessing(false)
        }).catch((err) => {
            console.log("space details error", err);
            setProcessing(false)
        })
    }

    useEffect(() => {
        spaceDetailAPICall()
    }, [])
    var price: any;
    var sfPrice: any;

    const formatNumber = (value: string) => {
        return parseFloat(value).toString();
    };



    const amountFormatter = (amount: any) => {
        const formattedAmount = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
            maximumFractionDigits: 2,
        }).format(amount);
        console.log("formattedAmount", formattedAmount);

        return formattedAmount;
    };

    if (spaceDetails?.price) {
        if (spaceDetails?.square_feet > 0) {
            price = `${amountFormatter(spaceDetails?.square_feet)} SF`
        }
    } else {
        if (spaceDetails?.square_feet) {
            price = `${amountFormatter(spaceDetails?.square_feet)} SF`
        }
        if (spaceDetails?.price_per_square) {
            sfPrice = `${amountFormatter(spaceDetails?.price_per_square)} PSF`
        } else {
            sfPrice = `$${amountFormatter(spaceDetails?.monthly_rent)} Mth`
        }
    }

    return (
        <>
            <Navbar transparent={false} />
            {isProcessing ?
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 " style={{}}>
                    <div className="fw-bold ms-1 my-0 text-center mt-3" style={{ color: "#AFABAB" }}><img src={processor} width={'10%'} height={'10%'} /></div>
                </div>
                :
                <>
                    <div className="featured_slick_gallery gray">
                        <div className="featured_slick_gallery-slide home-slider">
                            <Slider {...settings}>
                                {spaceDetails?.images?.map((spaceImage: any, spaceIndex: number) => (
                                    <div className="featured_slick_padd" key={spaceIndex} style={{ padding: 0 }}>
                                        <a href={spaceImage.image} className="">
                                            <img src={spaceImage.image} className="mx-auto" alt={`Space ${spaceIndex}`} height={500} width={850} style={{objectFit: "contain"}}/>
                                        </a>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>

                    <section className="gray-simple">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 col-md-12 col-sm-12">
                                    <div className="property_block_wrap style-2 p-4">
                                        <div className="prt-detail-title-desc">
                                            <span className="label text-light bg-success">{spaceDetails?.is_sale ? "For Sale" : "For Lease"}</span>
                                            <h3 className='mt-3'>{spaceDetails?.property_type}</h3>
                                            <span><i className="ni-map-markerni-map-marker"></i> {spaceDetails?.address}</span>
                                            {sfPrice && <h3 className="prt-price-fix text-primary mt-2">{sfPrice}</h3>}
                                            {spaceDetails?.price && <h3 className="prt-price-fix text-primary mt-2">{`$${amountFormatter(spaceDetails?.price)}`}</h3>}
                                            <div className="list-fx-features">
                                                {spaceDetails?.suite && <div className="listing-card-info-icon">
                                                    <div className="inc-fleat-icon me-1"><BsDoorOpen /></div>{spaceDetails?.suite} suite
                                                </div>}
                                                <div className="listing-card-info-icon">
                                                    <div className="inc-fleat-icon me-1"><img src={move} width="13" alt="" /></div>{price}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <PropertyDetail spaceDetails={spaceDetails} />
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                    <DetailSidebar spaceDetails={spaceDetails} />
                                </div>
                            </div>
                        </div>
                    </section>
                </>}
            <Footer />
        </>
    )
}